export const psicoName = [
  'Nutricionista',
  'Psicólogo',
  'psicologo',
  'nutricionista',
]
